let merkleDataTracker = null;
const setMerkleDataTracker = (merkleData) => {
  merkleDataTracker = merkleData;
};
export {
  merkleDataTracker,
  setMerkleDataTracker
};
